// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Dgpp","col":"styles_col__1BmSB"};